import { useEffect } from 'react'

import { motion, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import {
  Box,
  chakra,
  Heading,
  HStack,
  List,
  ListItem,
  useColorMode,
  useColorModeValue,
} from '@chakra-ui/react'

import { lanBenefits } from '@/lib/constants/benefitsTextConstants'
import {
  basicBgColorLeft,
  basicBgColorRight,
  basicTextColor,
} from '@/lib/constants/colorConstants'
import CustomImage from '@/components/Image'

import Title from './Title'

const Benefits = () => {
  const controls = useAnimation()
  const { inView, ref } = useInView()

  useEffect(() => {
    if (inView) {
      controls.start('visible')
    }
  }, [controls, inView])

  const boxVarients = {
    hidden: {
      scale: 0,
      opacity: 0,
    },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        duration: 1,
      },
    },
  }

  const { toggleColorMode: toggleMode, colorMode } = useColorMode()
  const borderColor = useColorModeValue('black', 'white')

  return (
    <>
      <Title />
      <chakra.section mx="auto" w="full">
        {lanBenefits &&
          lanBenefits.length > 0 &&
          lanBenefits.map((benefit, i) => (
            <HStack
              as={motion.div}
              animate={controls}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={boxVarients}
              key={i}
              w="full"
              h={{ base: 'auto', md: '80vh' }}
              alignItems="center"
              justifyContent="space-between"
              p="4.313rem"
              color={basicTextColor[colorMode]}
              bg={
                benefit.side === 'right'
                  ? basicBgColorRight[colorMode]
                  : basicBgColorLeft[colorMode]
              }
              flexDirection={benefit.side === 'right' ? 'row' : 'row-reverse'}
            >
              <Box display={{ base: 'none', md: 'block' }}>
                <CustomImage src={benefit.src} width={550} height={331.26} />
              </Box>
              <Box maxW="34.688rem">
                <Heading
                  fontSize={{ base: '1.5rem', md: '1.75rem' }}
                  fontWeight="medium"
                  color="primary"
                >
                  {benefit.title}
                </Heading>
                <Box
                  border="4px"
                  borderColor=""
                  w="4.688rem"
                  mt="1.25rem"
                  mb="3.525rem"
                ></Box>
                <List
                  listStyleType="none"
                  color="primary"
                  listStyleImg="primary"
                  ml="2.813rem"
                >
                  {benefit.text.map((el, i) => (
                    <ListItem
                      key={i}
                      fontSize="1rem"
                      fontWeight="normal"
                      lineHeight="33px"
                      color={basicTextColor[colorMode]}
                      maxW="29.625rem"
                      _notLast={{ mb: '0.5.938rem' }}
                      _before={{
                        content: `"\\2022"`,
                        color: 'primary',
                        fontWeight: 'bold',
                        fontSize: '2rem',
                        display: 'inline-block',
                        verticalAlign: 'middle',
                        w: '1.375rem',
                        ml: '-1.375rem',
                      }}
                    >
                      {el}
                    </ListItem>
                  ))}
                </List>
              </Box>
            </HStack>
          ))}
      </chakra.section>
    </>
  )
}

export default Benefits
